import {
  NumberParam,
  createEnumParam,
  useQueryParams,
  withDefault,
} from "use-query-params";

const versionValues = ["draft", "published"] as string[];
export type Version = (typeof versionValues)[number];
type Return = {
  version: Version;
  setVersion: (value: "draft" | "published") => void;
  versionId?: number | null;
  setVersionId: (value?: number) => void;
};
const useVersionQueryParams = (): Return => {
  const [query, setQuery] = useQueryParams({
    version: withDefault(createEnumParam(versionValues), "draft"),
    versionId: NumberParam,
  });
  const setVersion = (value: "draft" | "published") => {
    if (value === "published") {
      setQuery({ version: value, versionId: null });
    } else {
      setQuery({ version: value });
    }
  };
  const setVersionId = (value?: number) => {
    setQuery({ versionId: value, version: "draft" });
  };
  return {
    version: query.version,
    setVersion,
    versionId: query.versionId,
    setVersionId,
  };
};

export default useVersionQueryParams;
